export * from "-!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/framevuerk-builder/node_modules/pug-html-loader/lib/index.js!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/index.js??vue-loader-options!./fvMain.vue?vue&type=template&id=341476d1&lang=pug&"


//////////////////
// WEBPACK FOOTER
// ./src/components/fvMain.vue?vue&type=template&id=341476d1&lang=pug&
// module id = 83
// module chunks = 0 1